import { type } from "../types/types";

export const set_page_state = (pageState) => (dispatch) => {
  dispatch({
    type: type.SET_PAGE_STATE,
    pageState: pageState,
  });
};
